module.exports = __webpack_public_path__ + "img/thunder.b332505e.svg";